import React, { Component } from 'react'
import DragTracker from '../Cube/lib/drag-tracker'
import '../Cube/cube.css'
import { createPatternFromImage } from '../../../helper/fileHelper'
import {
    updateCubeByNodes,
    updateCubeSkewAngle,
    warpOnCubeWithControls,
} from '../../../helper/drawHelper'

export default function withDynamicCubeTool(WrappedComponent) {
    return class PerspectiveTool extends Component {
        constructor(props) {
            super(props)
            this.state = {
                _dynamicCubeState: {
                    ...this._defaultData,
                },
                showDynamicCube: false,
                showMenuCube: false,
                type: 1,
            }
        }

        _defaultData = {}

        dynamicCubeGenerator = () => {
            return (
                <React.Fragment>
                    <canvas id="dynamic-cube-canvas" />
                </React.Fragment>
            )
        }

        stateDynamicCubeHandler = (state = null, type = 6, callback) => {
            this.setState(
                {
                    showDynamicCube:
                        state === null ? !this.state.showDynamicCube : state,
                },
                () => {
                    if (state) {
                        this.initialDynamicCube(type)

                        if (callback) callback()
                    } else this.clearNodes()
                }
            )
        }

        clearNodes = () => {
            document.querySelectorAll('.node').forEach((node) => node.remove())
        }

        initialDynamicCube = (type = 1) => {
            let points = []
            let cornerPoints = [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
            ]
            let breakRatio = null
            let skewAngle = Math.PI / 4
            let isNew = true

            this.props.data.layers[0].children.forEach((element, index) => {
                if (
                    element.id === this.props.selectedItem &&
                    element.dimension
                ) {
                    isNew = false
                    this.pathData = element.pathData
                    const offsetX = document.querySelector('.Paper canvas')
                        .offsetLeft

                    cornerPoints = element.cubeData.cornerPoints.map((q) => {
                        return [q[0] + 0, q[1]]
                    })
                    breakRatio = element.cubeData.breakRatio
                    skewAngle = element.cubeData.skewAngle

                    points = this.getCubePoint(
                        element.dimension,
                        element.dimType
                    )
                } else if (element.id === this.props.selectedItem) {
                    this.pathData = element.pathData
                    points = this.getCubePointFromPath(type)
                }
            })

            this.points = points
            this.corner_points = cornerPoints
            this.skewAngle = skewAngle
            this.setState({ type })

            const canvas = document.getElementById('dynamic-cube-canvas')

            warpOnCubeWithControls(
                canvas,
                points,
                type,
                '/images/materials/material1.jpg',
                this.props.width,
                this.props.height,
                this.pathData,
                cornerPoints,
                breakRatio,
                skewAngle,
                isNew,
                ({ points, cornerPoints, breakRatio }) => {
                    this.points = points
                    this.cornerPoints = cornerPoints
                    this.breakRatio = breakRatio
                }
            )

            document.body.addEventListener('mousedown', this.onMouseDown)
        }

        getCubePoint = (dimension, type = 1) => {
            let points = []

            const offsetX = document.querySelector('.Paper canvas').offsetLeft

            dimension.forEach((dim, index) => {
                points[index] = [dim.x + offsetX, dim.y]
            })

            return points
        }

        getCubePointFromPath = (type) => {
            const paper = window.paper
            const canvas = document.getElementById('selection')
            paper.setup(canvas)
            paper.project.clear()
            const path = new paper.Path(this.pathData)

            const bounds = path.internalBounds
            let points = []
            if (type == 1) {
                points[0] = [bounds.left, bounds.top]
                points[1] = [bounds.right, bounds.top]
                points[2] = [bounds.right, bounds.bottom]
                points[3] = [bounds.left, bounds.bottom]
                points[4] = [bounds.right, bounds.bottom]
                points[5] = [bounds.left, bounds.bottom]
            } else if (type == 2) {
                points[0] = [
                    bounds.centerX + (bounds.right - bounds.centerX) / 3,
                    bounds.top,
                ]
                points[1] = [
                    bounds.centerX - (bounds.centerX - bounds.left) / 3,
                    bounds.top,
                ]
                points[2] = [
                    (bounds.centerX + bounds.left) / 2,
                    (bounds.top + bounds.centerY) / 2,
                ]
                points[3] = [
                    (bounds.centerX + bounds.right) / 2,
                    (bounds.top + bounds.centerY) / 2,
                ]
                points[4] = [(bounds.centerX + bounds.left) / 2, bounds.bottom]
                points[5] = [(bounds.centerX + bounds.right) / 2, bounds.bottom]
            } else if (type == 3) {
                points[0] = [bounds.left, bounds.top]
                points[1] = [(bounds.centerX + bounds.right) / 2, bounds.top]
                points[2] = [bounds.right, (bounds.top + bounds.centerY) / 2]
                points[3] = [
                    (bounds.centerX + bounds.left) / 2,
                    (bounds.top + bounds.centerY) / 2,
                ]
                points[4] = [bounds.right, bounds.bottom]
                points[5] = [(bounds.centerX + bounds.left) / 2, bounds.bottom]
            } else if (type == 4) {
                points[0] = [(bounds.centerX + bounds.left) / 2, bounds.top]
                points[1] = [bounds.right, bounds.top]
                points[2] = [
                    (bounds.centerX + bounds.right) / 2,
                    (bounds.top + bounds.centerY) / 2,
                ]
                points[3] = [bounds.left, (bounds.top + bounds.centerY) / 2]
                points[4] = [(bounds.centerX + bounds.right) / 2, bounds.bottom]
                points[5] = [bounds.left, bounds.bottom]
            } else if (type == 5) {
                points[0] = [bounds.left, bounds.top]
                points[1] = [(bounds.centerX + bounds.right) / 2, bounds.top]
                points[2] = [bounds.right, (bounds.top + bounds.centerY) / 2]
                points[3] = [
                    (bounds.centerX + bounds.left) / 2,
                    (bounds.top + bounds.centerY) / 2,
                ]
                points[4] = [bounds.left, (bounds.bottom + bounds.centerY) / 2]
                points[5] = [
                    (bounds.centerX + bounds.right) / 2,
                    (bounds.bottom + bounds.centerY) / 2,
                ]
                points[6] = [bounds.right, bounds.bottom]
                points[7] = [(bounds.centerX + bounds.left) / 2, bounds.bottom]
            } else if (type == 6) {
                points[0] = [(bounds.centerX + bounds.left) / 2, bounds.top]
                points[1] = [bounds.right, bounds.top]
                points[2] = [
                    (bounds.centerX + bounds.right) / 2,
                    (bounds.top + bounds.centerY) / 2,
                ]
                points[3] = [bounds.left, (bounds.top + bounds.centerY) / 2]
                points[4] = [
                    (bounds.centerX + bounds.left) / 2,
                    (bounds.bottom + bounds.centerY) / 2,
                ]
                points[5] = [bounds.right, (bounds.bottom + bounds.centerY) / 2]
                points[6] = [(bounds.centerX + bounds.right) / 2, bounds.bottom]
                points[7] = [bounds.left, bounds.bottom]
            } else if (type == 7) {
                // TODO: AMIR CHECK
                points[0] = [bounds.centerX, bounds.top]
                points[1] = [bounds.right, bounds.centerY]
                points[2] = [bounds.centerX, bounds.centerY]
                points[3] = [bounds.left, bounds.centerY]
                points[4] = [
                    bounds.centerX,
                    (bounds.bottom + bounds.centerY) / 2,
                ]
                points[5] = [bounds.right, (bounds.bottom + bounds.centerY) / 2]
                points[6] = [bounds.centerX, bounds.bottom]
                points[7] = [bounds.left, (bounds.bottom + bounds.centerY) / 2]
            }

            const offsetX = document.querySelector('.Paper canvas').offsetLeft
            for (const key in points) {
                points[key][0] += offsetX
            }

            return points
        }

        confirmDynamicCubeHandler = () => {
            const offsetX = document.querySelector('.Paper canvas').offsetLeft
            const offsetY = document.querySelector('.Paper canvas').offsetTop
            const { type } = this.state
      
            const dimension = this.points.map((point, index) => {
                return {
                    x: point[0] - offsetX,
                    y: point[1],
                }
            })
            const cornerPoints = this.cornerPoints.map((point, index) => {
                return [point[0] - 0, point[1]]
            })
            this.props.updateItemById(this.props.selectedItem, 0, {
                dimension: dimension.filter((node) => node != null),
                cubeData: {
                    cornerPoints,
                    breakRatio: this.breakRatio,
                    skewAngle: this.skewAngle,
                },
                dimType: type,
                plan: this.getPlanOfType(type),
                perspective: type,
            })

            this.stateDynamicCubeHandler(false)
        }

        deleteDynamicCubeHandler = () => {
            this.props.updateItemById(this.props.selectedItem, 0, {
                dimension: null,
                cubeData: null,
                dimType: null,
                plan: null,
                perspective: null,
            })

            this.stateDynamicCubeHandler(false)
        }

        getInitialCubeSkewAngle = () => {
            return (this.skewAngle * 180) / Math.PI
        }

        applyCubeSkewChange = (skewAngle) => {
            this.skewAngle = (skewAngle / 180) * Math.PI
            // TODO: DRAW AGAIN
            updateCubeSkewAngle(
                this.skewAngle,
                ({ points, cornerPoints, breakRatio }) => {
                    this.points = points
                    this.cornerPoints = cornerPoints
                    this.breakRatio = breakRatio
                }
            )
        }

        onMouseDown = (e) => {
            if (e.target.classList.contains('node')) {
                this.node = e.target

                document.body.addEventListener('mousemove', this.onMouseMove)

                document.body.onmouseup = () => {
                    document.body.removeEventListener(
                        'mousemove',
                        this.onMouseMove
                    )
                }
            }
        }

        onMouseMove = (e) => {
            updateCubeByNodes(
                e,
                this.node,
                ({ points, cornerPoints, breakRatio }) => {
                    this.points = points
                    this.cornerPoints = cornerPoints
                    this.breakRatio = breakRatio
                }
            )
        }

        getPlanOfType = (type) => {
            switch (type) {
                case 1:
                    return '1'
                    break
                case 2:
                case 3:
                case 4:
                    return '2'
                    break
                case 5:
                case 6:
                case 7:
                    return '3'
                    break
            }
        }

        getFacesOfType = (type, index) => {
            if (type >= 5) {
                let faces = null
                switch (type) {
                    case 5:
                        faces = [
                            ['Left'], // 0
                            ['Up', 'Left'], // 1
                            ['Up'], // 2
                            ['Up', 'Left', 'Right'], // 3
                            ['Up', 'Right'], // 4
                            ['Left', 'Right'], // 5
                            ['Right'], //6
                        ]
                        break
                    case 6:
                        faces = [
                            ['Up'], // 0
                            ['Up', 'Right'], // 1
                            ['Right'], // 2
                            ['Up', 'Left'], // 3
                            ['Up', 'Left', 'Right'], // 4
                            ['Left'], // 5
                            ['Left', 'Right'], // 6
                        ]
                        break
                    case 7:
                        faces = [
                            ['Left'], // 0
                            ['Up', 'Left'], // 1
                            ['Up'], // 2
                            ['Up', 'Left', 'Right'], // 3
                            ['Up', 'Right'], // 4
                            ['Left', 'Right'], // 5
                            ['Right'], // 6
                        ]
                        break

                    default:
                        break
                }

                return faces[index]
            } else {
                return null
            }
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    {...this.state}
                    showDynamicCube={this.state.showDynamicCube}
                    stateDynamicCubeHandler={this.stateDynamicCubeHandler}
                    confirmDynamicCubeHandler={this.confirmDynamicCubeHandler}
                    deleteDynamicCubeHandler={this.deleteDynamicCubeHandler}
                    dynamicCubeGenerator={this.dynamicCubeGenerator}
                    applyCubeSkewChange={this.applyCubeSkewChange}
                    getInitialCubeSkewAngle={this.getInitialCubeSkewAngle}
                    perspectiveType={this.state.type}
                />
            )
        }
    }
}
